// import { useState, useRef, useEffect } from 'react';
// import { Send } from 'lucide-react';
// import SearchLogo from '../../assets/search.svg';
// import { useDispatch } from 'react-redux';
// import { setStreaming } from '../../redux/slices/streamingSlice';

// export default function ChatInput({
//   input,
//   setInput,
//   handleSubmit,
//   handleKeyDown,
//   isDarkMode,
//   isResearchActive,
//   setIsResearchActive,
//   isLoading,
//   isStreamingResponse,
// }) {
//   const [isFocused, setIsFocused] = useState(false);

//   const dispatch = useDispatch();
//   const textareaRef = useRef(null);

//   useEffect(() => {
//     if (!isStreamingResponse && !isLoading) {
//       textareaRef.current?.focus();
//     }
//   }, [isStreamingResponse, isLoading]);

//   const suggestions = [
//     'State Specific Civil Laws',
//     'Legal Concepts',
//     'Case Conclusion',
//     'Draft a document',
//   ];

//   const handleResearchClick = () => {
//     setIsResearchActive((prev) => !prev);
//     dispatch(setStreaming(false));
//   };

//   return (
//     <div className="px-3 py-3 ">
//       <div className="max-w-3xl  mx-auto">
//         <form onSubmit={handleSubmit}>
//           <div
//             className={`chat-tour flex flex-col sm:flex-row rounded-lg relative ${
//               isDarkMode ? 'bg-gray-700' : 'bg-white'
//             } py-2 px-3 sm:py-3 sm:px-4 shadow-sm border transition-all ${
//               isFocused
//                 ? isDarkMode
//                   ? 'ring-1 ring-brand border-gray-600'
//                   : 'ring-2 ring-brand-100 border-brand-100'
//                 : isDarkMode
//                   ? 'border-gray-600'
//                   : 'border-gray-300'
//             }`}
//           >
//             <textarea
//               ref={textareaRef}
//               disabled={isLoading || isStreamingResponse}
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={handleKeyDown}
//               onFocus={() => setIsFocused(true)}
//               onBlur={() => setIsFocused(false)}
//               placeholder={
//                 isStreamingResponse
//                   ? 'Generating response...'
//                   : isLoading
//                     ? 'Waiting for response...'
//                     : isResearchActive
//                       ? 'Ask for deep research...'
//                       : 'Ask a legal question or research...'
//               }
//               className={`font-medium flex-grow py-4 sm:py-0 px-3 sm:px-0 outline-none resize-none text-xs sm:text-sm rounded-md w-full ${
//                 isDarkMode
//                   ? 'bg-gray-700 text-white placeholder-gray-400'
//                   : 'bg-white text-gray-900 placeholder-gray-500'
//               } ${
//                 isLoading || isStreamingResponse
//                   ? 'cursor-not-allowed opacity-60'
//                   : ''
//               }`}
//               rows={5}
//             />

//             <div
//               style={{ alignItems: 'flex-end' }}
//               className="flex flex-col sm:flex-row items-stretch sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 ml-0 sm:ml-3 mt-2 sm:mt-0 w-full sm:w-auto"
//             >
//               <button
//                 type="button"
//                 disabled={isLoading || isStreamingResponse}
//                 onClick={handleResearchClick}
//                 className={`flex items-center justify-center gap-2 px-6 py-2 rounded-md text-sm font-medium border transition-colors w-full sm:w-auto min-h-[40px] whitespace-nowrap ${
//                   isResearchActive
//                     ? isDarkMode
//                       ? 'bg-[#6A73EB] text-white border-[#6A73EB] hover:bg-[#5b63d9]'
//                       : 'bg-[#6A73EB] text-white border-[#6A73EB] hover:bg-[#7a82ec]'
//                     : isDarkMode
//                       ? 'border-[#9CA2F3] text-[#9CA2F3] bg-gray-800 hover:bg-gray-700'
//                       : 'border-[#9CA2F3] text-[#9CA2F3] bg-indigo-50 hover:bg-indigo-100'
//                 } ${
//                   isLoading || isStreamingResponse
//                     ? 'cursor-not-allowed opacity-60'
//                     : ''
//                 }`}
//               >
//                 <img
//                   src={SearchLogo}
//                   alt=""
//                   className={`research-tour h-4 w-4 ${
//                     isResearchActive ? 'filter brightness-0 invert' : ''
//                   }`}
//                 />
//                 Deep Research
//               </button>

//               {/* <button
//                 type="submit"
//                 disabled={isLoading || isStreamingResponse || !input?.trim()}
//                 className={`flex items-center justify-center px-3 py-2 rounded-md text-sm font-medium border transition-colors w-full sm:w-auto min-h-[40px] ${
//                   input.trim()
//                     ? isDarkMode
//                       ? 'border-brandLight bg-brand text-white hover:bg-brand'
//                       : 'border-brandLight bg-brand text-white hover:bg-brand'
//                     : isDarkMode
//                     ? 'border-gray-600 text-gray-500 bg-gray-700 cursor-not-allowed'
//                     : 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'
//                 } ${
//                   isLoading || isStreamingResponse
//                     ? 'cursor-not-allowed opacity-60'
//                     : ''
//                 }`}
//               >
//                 <Send className="h-4 w-4 mr-2" />
//                 <span>Send</span>
//               </button> */}
//               <button
//                 type="submit"
//                 disabled={isLoading || isStreamingResponse || !input?.trim()}
//                 className={`flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium border transition-colors
//     w-full sm:w-auto min-h-[40px] whitespace-nowrap ${
//       input.trim()
//         ? 'border-brandLight bg-brand text-white hover:bg-brand'
//         : isDarkMode
//           ? 'border-gray-600 text-gray-500 bg-gray-700 cursor-not-allowed'
//           : 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'
//     } ${
//       isLoading || isStreamingResponse ? 'cursor-not-allowed opacity-60' : ''
//     }`}
//               >
//                 <Send className="h-4 w-4 mr-2 shrink-0" />
//                 <span className="whitespace-nowrap">
//                   {isResearchActive ? 'Run Deep Research' : 'Quick Search'}
//                 </span>
//               </button>
//             </div>
//           </div>
//           {suggestions.length > 0 && (
//             <div className="hidden sm:flex flex-wrap justify-center gap-2 mt-3">
//               {suggestions.map((tag, idx) => (
//                 <button
//                   key={idx}
//                   type="button"
//                   disabled={isLoading || isStreamingResponse}
//                   onClick={() => {
//                     setInput(tag); // or setInput((prev) => `${prev} ${tag}`) to append
//                     textareaRef.current?.focus();
//                   }}
//                   className={`px-5 py-1 rounded-full text-xs border transition-all
//           ${
//             isDarkMode
//               ? 'bg-gray-700 text-gray-100 border-gray-600'
//               : 'bg-white text-gray-600 border-zinc-200'
//           }
//           ${
//             isLoading || isStreamingResponse
//               ? 'cursor-not-allowed opacity-60'
//               : 'hover:opacity-80 cursor-pointer'
//           }`}
//                 >
//                   {tag}
//                 </button>
//               ))}
//             </div>
//           )}
//         </form>
//       </div>
//     </div>
//   );
// }
import { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown, Check, Send } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setStreaming } from '../../redux/slices/streamingSlice';
import { getChatSuggestions } from '../../api/api';

export default function ChatInput({
  input,
  setInput,
  handleSubmit,
  handleKeyDown,
  isDarkMode,
  isResearchActive,
  setIsResearchActive,
  isLoading,
  isStreamingResponse,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(true);

  const dispatch = useDispatch();
  const uid = useSelector((state) => state.auth.user?.id);
  const textareaRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isStreamingResponse && !isLoading) {
      textareaRef.current?.focus();
    }
  }, [isStreamingResponse, isLoading]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (!uid) return;
    setSuggestionsLoading(true);
    getChatSuggestions(uid)
      .then((data) => {
        const list = data?.suggestions || [];
        if (list.length > 0) setSuggestions(list);
      })
      .catch(() => {})
      .finally(() => setSuggestionsLoading(false));
  }, [uid]);

  const modes = [
    {
      label: 'uLegal',
      value: false,
    },
    {
      label: 'Deep Research',
      value: true,
    },
  ];

  const selectedMode = isResearchActive ? 'Deep Research' : 'uLegal';

  const handleModeSelect = (value) => {
    setIsResearchActive(value);
    dispatch(setStreaming(false));
    setIsDropdownOpen(false);
  };

  return (
    <div className="px-3 py-3">
      <div className="max-w-3xl mx-auto">
        <form onSubmit={handleSubmit}>
          <div
            className={`chat-tour flex flex-col sm:flex-row rounded-lg relative ${
              isDarkMode ? 'bg-gray-700' : 'bg-white'
            } py-2 px-3 sm:py-3 sm:px-4 shadow-sm border transition-all ${
              isFocused
                ? isDarkMode
                  ? 'ring-1 ring-brand border-gray-600'
                  : 'ring-2 ring-brand-100 border-brand-100'
                : isDarkMode
                  ? 'border-gray-600'
                  : 'border-gray-300'
            }`}
          >
            <textarea
              ref={textareaRef}
              disabled={isLoading || isStreamingResponse}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              placeholder={
                isStreamingResponse
                  ? 'Generating response...'
                  : isLoading
                    ? 'Waiting for response...'
                    : isResearchActive
                      ? 'Ask for deep research...'
                      : 'Ask a legal question or research...'
              }
              className={`font-medium flex-grow py-4 sm:py-0 px-3 sm:px-0 outline-none resize-none text-xs sm:text-sm rounded-md w-full ${
                isDarkMode
                  ? 'bg-gray-700 text-white placeholder-gray-400'
                  : 'bg-white text-gray-900 placeholder-gray-500'
              } ${
                isLoading || isStreamingResponse
                  ? 'cursor-not-allowed opacity-60'
                  : ''
              }`}
              rows={5}
            />

            <div className="flex items-end gap-3 ml-0 sm:ml-4 mt-3 sm:mt-0 w-full sm:w-auto">
              {/* Mode Selector */}
              <div
                ref={dropdownRef}
                className="relative flex-1 sm:flex-none sm:min-w-[150px] shrink-0"
              >
                {' '}
                <button
                  type="button"
                  disabled={isLoading || isStreamingResponse}
                  onClick={() => setIsDropdownOpen((prev) => !prev)}
                  className={`w-full h-[40px] flex items-center justify-between gap-2 px-4 rounded-full text-sm font-semibold border transition-all
      ${
        isDarkMode
          ? 'bg-gray-800 text-gray-100 border-gray-600 hover:bg-gray-700'
          : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
      }
      ${
        isLoading || isStreamingResponse
          ? 'cursor-not-allowed opacity-60'
          : 'cursor-pointer'
      }`}
                >
                  <span className="block flex-1 text-center whitespace-nowrap">
                    {selectedMode}
                  </span>

                  <motion.span
                    animate={{ rotate: isDropdownOpen ? 180 : 0 }}
                    transition={{ duration: 0.18, ease: 'easeOut' }}
                    className="flex shrink-0"
                  >
                    <ChevronDown className="h-4 w-4 opacity-70" />
                  </motion.span>
                </button>
                <AnimatePresence>
                  {isDropdownOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: 8, scale: 0.97 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: 8, scale: 0.97 }}
                      transition={{ duration: 0.16, ease: 'easeOut' }}
                      className={`absolute bottom-full right-0 mb-2 w-[210px] rounded-2xl border shadow-xl overflow-hidden z-50 p-1
          ${
            isDarkMode
              ? 'bg-gray-800 border-gray-700'
              : 'bg-white border-gray-200'
          }`}
                    >
                      {modes.map((mode) => {
                        const active = isResearchActive === mode.value;

                        return (
                          <button
                            key={mode.label}
                            type="button"
                            onClick={() => handleModeSelect(mode.value)}
                            className={`w-full flex items-center justify-between gap-3 px-3.5 py-2.5 rounded-xl text-sm transition
                ${
                  active
                    ? isDarkMode
                      ? 'bg-gray-700 text-white font-semibold'
                      : 'bg-gray-100 text-gray-900 font-semibold'
                    : isDarkMode
                      ? 'text-gray-300 hover:bg-gray-700 hover:text-white font-medium'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900 font-medium'
                }`}
                          >
                            <span className="whitespace-nowrap">
                              {mode.label}
                            </span>

                            {active && (
                              <Check className="h-4 w-4 shrink-0 opacity-80" />
                            )}
                          </button>
                        );
                      })}
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Search Button */}
              <button
                type="submit"
                disabled={isLoading || isStreamingResponse || !input?.trim()}
                className={`flex items-center justify-center p-2.5 rounded-md text-sm font-medium border transition-colors
    w-10 h-10 shrink-0 ${
      input.trim()
        ? 'border-brandLight bg-brand text-white hover:bg-brand'
        : isDarkMode
          ? 'border-gray-600 text-gray-500 bg-gray-700 cursor-not-allowed'
          : 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'
    } ${
      isLoading || isStreamingResponse ? 'cursor-not-allowed opacity-60' : ''
    }`}
              >
                <Send className="h-4 w-4" />
              </button>
            </div>
          </div>
        </form>
        {suggestionsLoading ? (
          <div className="hidden sm:flex flex-col items-center gap-2 mb-3 mt-3">
            {/* First line (single centered) */}
            <div
              style={{ width: 320 }}
              className={`h-9 rounded-full animate-pulse border px-4
      ${
        isDarkMode
          ? 'bg-gray-700 border-gray-600'
          : 'bg-gray-100 border-gray-200'
      }
    `}
            />

            {/* Second line (two pills) */}
            <div className="flex gap-2 justify-center">
              {[260, 280].map((w, idx) => (
                <div
                  key={idx}
                  style={{ width: w }}
                  className={`h-9 rounded-full animate-pulse border px-4
          ${
            isDarkMode
              ? 'bg-gray-700 border-gray-600'
              : 'bg-gray-100 border-gray-200'
          }
        `}
                />
              ))}
            </div>
          </div>
        ) : suggestions.length > 0 ? (
          <div className="hidden sm:flex flex-wrap justify-center gap-2 mt-2">
            {suggestions.slice(0, 3).map((tag, idx) => (
              <button
                key={idx}
                type="button"
                disabled={isLoading || isStreamingResponse}
                onClick={() => {
                  setInput(tag);
                  textareaRef.current?.focus();
                }}
                className={`px-5 py-1 rounded-full text-xs border transition-all
                  ${
                    isDarkMode
                      ? 'bg-gray-700 text-gray-100 border-gray-600'
                      : 'bg-white text-gray-600 border-zinc-200'
                  }
                  ${
                    isLoading || isStreamingResponse
                      ? 'cursor-not-allowed opacity-60'
                      : 'hover:opacity-80 cursor-pointer'
                  }`}
              >
                {tag}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

